<script setup lang="ts">
import { PhArrowLeft, PhArrowRight } from '@phosphor-icons/vue'

import RouteCodeBadge from '@/components/transit/RouteCodeBadge.vue'
import type { DirectionKey } from '@/types'
import { directionLabel } from '@/utils/direction'

defineProps<{ code: string; name: string; direction: DirectionKey }>()
</script>

<template>
  <button
    type="button"
    class="flex w-full items-center gap-3 border-b px-3 py-3 text-left transition-colors hover:bg-muted"
  >
    <RouteCodeBadge :code="code" />

    <span class="min-w-0 flex-1">
      <span class="block text-sm">{{ name }}</span>
      <span
        class="mt-1 flex items-center gap-1.5 text-xs font-bold"
        :class="direction === 'outbound' ? 'text-route-outbound' : 'text-route-inbound'"
      >
        <PhArrowRight v-if="direction === 'outbound'" class="size-4" />
        <PhArrowLeft v-else class="size-4" />
        {{ directionLabel(direction) }}
      </span>
    </span>
  </button>
</template>
